import Vue from 'vue';
import Vuetify from 'vuetify';
import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/dist/vuetify.min.css';
import ru from 'vuetify/es5/locale/ru';

Vue.use(Vuetify);

const preset = {
  breakpoint: {
    scrollBarWidth: 16,
    thresholds: {
      xs: 600,
      sm: 960,
      md: 1280,
      lg: 1920,
    },
  },
  icons: {
    iconfont: 'mdi',
    values: {},
  },
  rtl: false,
  theme: {
    dark: false,
    default: 'light',
    disable: false,
    options: {
      cspNonce: undefined,
      customProperties: undefined,
      minifyTheme: undefined,
      themeCache: undefined,
    },
    themes: {
      light: {
        primary: '#dd57a5',
        secondary: '#7ae4dc',
        accent: '#82B1FF',
        error: '#F84283',
        info: '#2196F3',
        success: '#2CA768',
        warning: '#FB8C00',
      },
      dark: {
        primary: '#118DD7',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#F84283',
        info: '#2196F3',
        success: '#2CA768',
        warning: '#FB8C00',
      },
    },
  },
};
const opts = {
  lang: {
    locales: { ru },
    current: 'ru',
  },
  preset,
};
export default new Vuetify(opts);
